import { Link } from "react-router-dom";
import { FadeUp, Overline } from "@/components/Reveal";
import LegalTexts from "@/components/LegalTexts";

export default function Termeni() {
  return (
    <div className="mx-auto max-w-4xl px-4 pb-28 pt-36 sm:px-8 lg:px-12">
      <FadeUp>
        <Overline>Documente oficiale</Overline>
        <h1
          data-testid="termeni-page-title"
          className="mt-4 font-display text-3xl font-black uppercase leading-[1.02] tracking-tight text-white sm:text-4xl lg:text-5xl"
        >
          Termeni, acorduri &amp; <span className="text-neon">GDPR</span>
        </h1>
        <p className="mt-6 text-base leading-relaxed text-neutral-400">
          Documentele pe care le semnezi electronic la înscrierea în
          mini-campionatul de fotbal caritabil organizat de Asociația Art &amp;
          Outdoor România.
        </p>
      </FadeUp>
      <FadeUp delay={0.1} className="mt-16">
        <LegalTexts />
      </FadeUp>
      <FadeUp delay={0.2}>
        <p className="mt-16 text-sm text-neutral-500">
          Întrebări? Scrie-ne prin{" "}
          <Link to="/contact" data-testid="termeni-contact-link" className="text-neon underline-offset-4 hover:underline">
            pagina de contact
          </Link>{" "}
          sau la contact@artandoutdoor.com.
        </p>
      </FadeUp>
    </div>
  );
}
